var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.606,
    height: 11.574,
    viewBox: "0 0 16.606 11.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Oval-1",
    d: "M29.12,26.213a2.1,2.1,0,0,1-1.795,1.632,55.763,55.763,0,0,1-6.218.23,55.76,55.76,0,0,1-6.218-.23,2.1,2.1,0,0,1-1.795-1.632,17.8,17.8,0,0,1-.289-3.925,17.81,17.81,0,0,1,.292-3.926,2.1,2.1,0,0,1,1.795-1.632,55.765,55.765,0,0,1,6.219-.23,55.761,55.761,0,0,1,6.218.23,2.1,2.1,0,0,1,1.795,1.632,17.8,17.8,0,0,1,.287,3.926A17.806,17.806,0,0,1,29.12,26.213Zm-9.507-6.989,4.6,2.653-4.6,2.653Zm0,0",
    transform: "translate(-12.805 -16.5)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.1d981432c4ea905792a566a81fe7033e.svg";
export { ForwardRef as ReactComponent };